import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GenderPipe } from '@shared/pipes/naipe.pipe';
import { StepParameterizationService } from '@shared/services/competition/step-parametrization.service';
import { EventService } from '@shared/services/event.service';
import { catchError, filter, map, of, shareReplay, switchMap, tap } from 'rxjs';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';

type RoundManagementInfo = {
  petTxNome: string;
  formatoInfo: string;
  categoriaInfo: string;
  eveTxNome: string;
  bloTxNome: string;
  comTxNome: string;
  petDescription: string;
};

@Component({
  selector: 'sigecom-round-management-info',
  templateUrl: './round-management-info.component.html',
  host:{class:'block'}
})
export class RoundManagementInfoComponent
  extends BaseComponent
  implements OnInit
{
  @Input() petNrId = -1;
  @Output() petDescriptionChange = new EventEmitter<string>();

  readonly #route = inject(ActivatedRoute);
  readonly #stepParametrizationService = inject(StepParameterizationService);
  readonly #eventService = inject(EventService);

  public simpleStepParametrization$ = of<RoundManagementInfo>({
    petTxNome: '',
    formatoInfo: '',
    categoriaInfo: '',
    eveTxNome: '',
    bloTxNome: '',
    comTxNome: '',
    petDescription: '',
  });

  ngOnInit(): void {
    const petNrId$ =
      this.petNrId > 0
        ? of(this.petNrId)
        : this.#route.paramMap.pipe(
            map((params) => Number(params.get('petNrId') || -1)),
          );

    this.simpleStepParametrization$ = petNrId$.pipe(
      filter((petNrId) => petNrId > 0),
      switchMap((petNrId) =>
        this.#stepParametrizationService.getStepParametrizationById$(petNrId),
      ),
      switchMap((step) => {
        const categoria = step.petObjCategoria;
        const event$ = categoria?.catNrId
          ? this.#eventService
              .getEventByCatNrId(categoria.catNrId)
              .pipe(catchError(() => of(undefined)))
          : of(undefined);

        return event$.pipe(map((event) => ({ step, categoria, event })));
      }),
      map(({ step, categoria, event }) => {
        const genderPipe = new GenderPipe();
        const description = `${event?.eveTxNome ?? ''} - ${genderPipe.transform(
          categoria?.catTxSexo,
        )}`.trim();

        return {
          petTxNome: step.petTxNome ?? '',
          formatoInfo: categoria?.catTxTipoInscricao ?? '',
          categoriaInfo: categoria
            ? `${categoria.catNrAnoInicio} - ${categoria.catNrAnoFim}`
            : '',
          eveTxNome: event?.eveTxNome ?? '',
          bloTxNome: step.bloObjCompeticao?.bloTxNome ?? '',
          comTxNome: step.comObjCompeticao?.comTxNome ?? '',
          petDescription: description,
        };
      }),
      tap((info) => this.petDescriptionChange.emit(info.petDescription)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }
}
